<template src="./template.html"></template>

<script>
import EmptyingTemplateDescription from '@/components/EmptyingTemplates/Description.vue'
import { emptyingIntervalOptions } from '@/components/mixins/constants'
import dateUtils from '@/components/mixins/dateUtils'

export default {
  name: 'EmptyingTemplateNewForm',
  mixins: [dateUtils],
  components: {
    EmptyingTemplateDescription,
  },
  props: {
    afterSubmit: Function,
  },
  data() {
    return {
      emptyingInterval: null,
      emptyTemplate: {},
      templateMode: 'add',
    }
  },
  computed: {
    intervalOptions() {
      return emptyingIntervalOptions[this.$i18n.locale]
    },
    submitButtonDisabled() {
      return (
        this.emptyTemplate.reference_date == null ||
        this.emptyTemplate.reference_date == '' ||
        this.emptyingInterval === null
      )
    },
  },
  methods: {
    async submitEmptyingTemplate() {
      this.emptyTemplate.repeat_interval = this.emptyingInterval === 'once' ? null : this.emptyingInterval
      this.emptyTemplate.repeat_type = this.emptyingInterval === 'once' ? 'once' : 'recurring'
      this.afterSubmit(this.emptyTemplate)
    },
  },
}
</script>
<style lang="scss" src="./styles.scss" scoped />
